var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTbbannericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12_1930)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 65,
    height: 65,
    rx: 32.5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#D8EAF9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_1930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4841 54.9923C55.7192 54.9923 57.531 53.0336 57.531 50.6173C57.531 48.2011 55.7192 46.2423 53.4841 46.2423C51.2491 46.2423 49.4373 48.2011 49.4373 50.6173C49.4373 53.0336 51.2491 54.9923 53.4841 54.9923Z",
    fill: "#00BD7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1598 28.5611C48.7266 28.4116 48.2669 28.3748 47.8181 28.4535C47.3692 28.5322 46.9439 28.7243 46.5766 29.0142C46.2094 29.3041 45.9105 29.6835 45.7044 30.1217C45.4983 30.5599 45.3907 31.0445 45.3904 31.5361V38.5173C44.6444 37.5193 44.2364 36.2755 44.2342 34.9923V21.8673C44.2342 21.7015 44.1733 21.5426 44.0649 21.4254C43.9564 21.3082 43.8094 21.2423 43.6561 21.2423H41.3436C41.1902 21.2423 41.0432 21.3082 40.9348 21.4254C40.8263 21.5426 40.7654 21.7015 40.7654 21.8673V34.9923C40.7632 36.2755 40.3552 37.5193 39.6092 38.5173V31.5361C39.6089 31.0445 39.5013 30.5599 39.2952 30.1217C39.0891 29.6835 38.7903 29.3041 38.423 29.0142C38.0557 28.7243 37.6304 28.5322 37.1816 28.4535C36.7327 28.3748 36.273 28.4116 35.8398 28.5611C32.9022 29.5627 30.3375 31.5527 28.5196 34.2409C26.7018 36.9291 25.7258 40.1749 25.7342 43.5048V56.8673C25.7342 57.0331 25.7951 57.192 25.9035 57.3093C26.0119 57.4265 26.159 57.4923 26.3123 57.4923H29.7811C32.3876 57.4923 34.8875 56.3729 36.7306 54.3803C38.5737 52.3877 39.6092 49.6852 39.6092 46.8673V43.3736L41.199 41.6611C41.5446 41.2893 42.0123 41.0806 42.4998 41.0806C42.9873 41.0806 43.455 41.2893 43.8006 41.6611L45.3904 43.3736V46.8673C45.3904 49.6852 46.4259 52.3877 48.269 54.3803C50.1122 56.3729 52.612 57.4923 55.2186 57.4923H58.6873C58.8406 57.4923 58.9877 57.4265 59.0961 57.3093C59.2045 57.192 59.2654 57.0331 59.2654 56.8673V43.5048C59.2738 40.1749 58.2979 36.9291 56.48 34.2409C54.6621 31.5527 52.0974 29.5627 49.1598 28.5611ZM38.4529 46.8673C38.4529 48.0985 38.2286 49.3175 37.7928 50.455C37.357 51.5924 36.7183 52.6259 35.913 53.4964C35.1077 54.367 34.1518 55.0575 33.0996 55.5287C32.0475 55.9998 30.9199 56.2423 29.7811 56.2423H26.8904V43.5048C26.8827 40.4403 27.7811 37.4533 29.4545 34.9798C31.1279 32.5062 33.4887 30.6755 36.1925 29.7548C36.452 29.6655 36.7274 29.6435 36.9963 29.6907C37.2652 29.7378 37.52 29.8528 37.7402 30.0263C37.9603 30.1997 38.1395 30.4268 38.2634 30.6891C38.3872 30.9514 38.4521 31.2416 38.4529 31.5361V46.8673ZM44.6215 40.7736C44.0573 40.1682 43.2947 39.8286 42.4998 39.8286C41.7049 39.8286 40.9423 40.1682 40.3781 40.7736L39.6092 41.6111V40.2923C40.3305 39.6462 40.9116 38.8365 41.3112 37.9206C41.7108 37.0047 41.9192 36.005 41.9217 34.9923V22.4923H43.0779V34.9923C43.0804 36.005 43.2888 37.0047 43.6884 37.9206C44.0881 38.8365 44.6691 39.6462 45.3904 40.2923V41.6111L44.6215 40.7736ZM58.1092 56.2423H55.2186C52.9186 56.2423 50.7129 55.2546 49.0866 53.4964C47.4603 51.7383 46.5467 49.3537 46.5467 46.8673V31.5361C46.5467 31.0388 46.7294 30.5619 47.0547 30.2102C47.3799 29.8586 47.8211 29.6611 48.2811 29.6611C48.4613 29.6621 48.6405 29.6916 48.8129 29.7486C51.5165 30.6707 53.8768 32.5028 55.5491 34.9775C57.2215 37.4522 58.1185 40.44 58.1092 43.5048V56.2423Z",
    fill: "#004276"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12_1930",
    x: 0,
    y: 0,
    width: 85,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12_1930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12_1930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_1930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 40,
    fill: "white",
    transform: "translate(24 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbbannericon);
export default __webpack_public_path__ + "static/media/tb banner icon.9332a4a2f14d5b56d0c7fab8cf5da21b.svg";
export { ForwardRef as ReactComponent };